import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import * as z from "zod/v4";

export const generateWorkOrderBarcodeLabels = {
  name: "generateWorkOrderBarcodeLabels" as const,
  input: z.object({
    workOrderIds: z.array(z.string()),
    labelSize: z.enum(barcodeLabelSize).optional(),
    printerId: z.number().int().optional(),
    labelQuantity: z.number().int().positive().optional(),
  }),
  output: z.object({
    pdfBase64: z.string(),
    printJobId: z.number().optional(),
  }),
};
